// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const materialPatchInPositionOneMin = 0;
export const materialPatchInPositionOneMax = 10000;

export const materialPatchInTitleOneMax = 200;

export const MaterialPatchIn = zod.object({
  "audience": zod.union([zod.enum(['internal', 'shareable']),zod.null()]).optional(),
  "material_type": zod.union([zod.enum(['one_pager', 'executive_deck', 'technical_deck', 'commercial_model', 'demo', 'case_study', 'architecture', 'other']),zod.null()]).optional(),
  "position": zod.union([zod.int().min(materialPatchInPositionOneMin).max(materialPatchInPositionOneMax),zod.null()]).optional(),
  "revision": zod.int().min(1),
  "superseded_by": zod.union([zod.uuid(),zod.null()]).optional(),
  "title": zod.union([zod.string().min(1).max(materialPatchInTitleOneMax),zod.null()]).optional()
});

export type MaterialPatchIn = zod.input<typeof MaterialPatchIn>;
export type MaterialPatchInOutput = zod.output<typeof MaterialPatchIn>;
